"use client";
const i = (n, e) => {
  const u = n.split("(")[1].split(")")[0].split(",").map((a) => Number.parseInt(a, 10));
  let t = u[0], s = u[1], r = u[2];
  return t = t * (100 + e) / 100, s = s * (100 + e) / 100, r = r * (100 + e) / 100, t = t < 255 ? t : 255, s = s < 255 ? s : 255, r = r < 255 ? r : 255, t = t > 0 ? t : 0, s = s > 0 ? s : 0, r = r > 0 ? r : 0, `rgb(${Math.round(t)}, ${Math.round(s)}, ${Math.round(r)})`;
}, l = (n, e) => i(n, -e), p = (n, e) => n.startsWith("rgb") ? `rgba(${n.split("(")[1].split(",").map((t) => parseInt(t)).join(",")},${e})` : n;
export {
  l as darken,
  i as lighten,
  p as opacity
};
